import { useState } from "react";
import { Modal } from "react-bootstrap";
import { BsInfo } from "react-icons/bs";
import { MdCheck, MdOutlineCopyAll } from "react-icons/md";
import { useParams } from "react-router-dom";
import { useLanguage } from "../Translations/LenguageContext";

const python_snippet = (endpoint) => {
    return `
import requests

API_KEY = "<your_api_key_here>"
URL = "${endpoint}"

payload = {
    "param1": "value1",
    "param2": "value2"
}

headers = {
    "Authorization": f"Bearer {API_KEY}",
    "Content-Type": "application/json",
}

response = requests.post(URL, json=payload, headers=headers)

print(response.status_code)
print(response.text)
`
}

const js_snippet = (endpoint) => {
    return `
const API_KEY = "<your_api_key_here>";
const url = "${endpoint}";

const payload = {
  param1: "value1",
  param2: "value2"
};

fetch(url, {
  method: "POST",
  headers: {
    "Authorization": \`Bearer \${API_KEY}\`,
    "Content-Type": "application/json"
  },
  body: JSON.stringify(payload)
})
  .then(res => res.json())
  .then(data => console.log(data))
  .catch(err => console.error(err));
`
}


const InfoModal = ({ show, handleClose, mcpData }) => {
    const {t} = useLanguage()
    const { org_id, runtime, mcp_id, version_n } = useParams()
    const [codeView, setCodeView] = useState("py")
    const [checkCopy, setCheckCopy] = useState(false)
    const endpoint = `https://api.projecte8.com/ability/${org_id}/${mcp_id}/<your-endpoint>`

    const copyItem = (item) => {
        navigator.clipboard.writeText(item)
            .then(() => {
                setCheckCopy(true);
                setTimeout(() => {
                    setCheckCopy(false);
                }, 2000);
            })
            .catch((err) => {
                console.error("Failed to copy: ", err);
            });
    };
    return (
        <Modal show={show} onHide={handleClose} centered className="mcp_modal_custom">
            <div className="modal_header">
                <p className="modal_header_title">{t.abilities.ability_info} <BsInfo /></p>
            </div>

            <div className="modal_main_cont">
                {mcpData.mcp_name ? (
                    <div className="info_mcp_modal_cont">
                        <div className="persona_reg">
                            <div className="label_input">
                                <label className="input_label">ID</label>
                                <p className="register_form_first register_form_first_disabled fade-in">{mcpData.id}</p>
                            </div>
                            <div className="label_input">
                                <label className="input_label">{t.title}</label>
                                <p className="register_form_first register_form_first_disabled fade-in">{mcpData.mcp_name}</p>
                            </div>
                        </div>

                        <div className="persona_reg">
                            {mcpData.drafted_version && (
                                <div className="label_input">
                                    <label className="input_label">{t.abilities.drafted_version}</label>
                                    <p className="register_form_first register_form_first_disabled fade-in">v{mcpData.drafted_version}</p>
                                </div>
                            )}
                            {mcpData.version && (
                                <div className="label_input">
                                    <label className="input_label">{t.abilities.published_version}</label>
                                    <p className="register_form_first register_form_first_disabled fade-in">v{mcpData.version}</p>
                                </div>
                            )}
                        </div>

                        {mcpData.endpoint_url && (
                            <div className="persona_reg">
                                <div className="label_input">
                                    <label className="input_label">{t.abilities.endpoint_url}</label>
                                    <p className="register_form_first register_form_first_disabled fade-in" onClick={() => copyItem(endpoint)}><span>{endpoint}</span> {checkCopy ? <i className="fade-in"> <MdCheck /></i> : <i className="fade-in"><MdOutlineCopyAll /></i>}</p>
                                </div>
                            </div>
                        )}

                        {mcpData.endpoint_url && (
                        <div className="example_code">
                            <div className="example_code_header">
                                <button className={`example_code_header_btn ${codeView == "py" && "example_code_header_btn_selected"}`} onClick={() => setCodeView("py")}>Py</button>
                                <button className={`example_code_header_btn ${codeView == "js" && "example_code_header_btn_selected"}`} onClick={() => setCodeView("js")}>Js</button>
                            </div>
                            <div className="code_view_example">
                                <pre>
                                    <code>
                                        {codeView === "py" ? python_snippet(endpoint) : js_snippet(endpoint)}
                                    </code>
                                </pre>
                            </div>
                        </div>
                        )} 
                    </div>
                ) : (
                    <div className="info_mcp_modal_cont">
                        <p>{t.no_data}</p>

                    </div>
                )}
            </div>

            <div className="modal_footer">
                <span></span>
                <div className="modal_footer_btn_cont">
                    <button className="modale_close_btn" onClick={handleClose}>
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default InfoModal;